// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-features-Auth-Loading-style__component--OjkP8{display:flex;align-items:center;flex-direction:column;justify-content:center;position:absolute;width:100%;height:100%;background:#c5ddeb}.src-features-Auth-Loading-style__component--OjkP8.src-features-Auth-Loading-style__hide--yIu0i{display:none}.src-features-Auth-Loading-style__loading--iGV2D{margin:35px 0;text-align:center;color:#28a3db;font-size:12px;font-weight:bold}.src-features-Auth-Loading-style__title--TbKJt{text-align:center;color:#064889;font-size:24px;font-weight:bold}`, "",{"version":3,"sources":["webpack://./src/features/Auth/Loading/style.scss"],"names":[],"mappings":"AACA,mDACE,YAAA,CACA,kBAAA,CACA,qBAAA,CACA,sBAAA,CACA,iBAAA,CACA,UAAA,CACA,WAAA,CACA,kBAAA,CAEA,gGACE,YAAA,CAIJ,iDACE,aAAA,CACA,iBAAA,CACA,aAAA,CACA,cAAA,CACA,gBAAA,CAGF,+CACE,iBAAA,CACA,aAAA,CACA,cAAA,CACA,gBAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.component {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: #c5ddeb;\n\n  &.hide {\n    display: none;\n  }\n}\n\n.loading {\n  margin: 35px 0;\n  text-align: center;\n  color: #28a3db;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.title {\n  text-align: center;\n  color: #064889;\n  font-size: 24px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": `56px`,
	"lCompanyHeight": `114px`,
	"h2FontSize": `28px`,
	"h3FontSize": `20px`,
	"bodyLineHeight": `20px`,
	"lGnShrinkWindowWidth": `1591px`,
	"tableVerticalPadding": `8px`,
	"tableHorizontalPadding": `16px`,
	"lPersonnelBreakWidth": `1599px`,
	"cNavigationAccent": `#f57f17`,
	"cTableBodyOdd": `#fff`,
	"cTableBodyEven": `#f2f6f8`,
	"cTableHover": `#c5ddeb`,
	"cTableHeadOdd": `#eaf1f5`,
	"cTableHeadEven": `#dee8ef`,
	"zPageLoading": `2`,
	"component": `src-features-Auth-Loading-style__component--OjkP8`,
	"hide": `src-features-Auth-Loading-style__hide--yIu0i`,
	"loading": `src-features-Auth-Loading-style__loading--iGV2D`,
	"title": `src-features-Auth-Loading-style__title--TbKJt`
};
export default ___CSS_LOADER_EXPORT___;
